import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSurveyStore } from 'Store/Survey'
import { shallow } from 'zustand/shallow'

/** Ensures GET /survey/:id matches the route param (shared header + tab data). */
const useFetchSurveyDetail = () => {
  const { id } = useParams<{ id: string }>()
  const { selected, getOne } = useSurveyStore(
    state => ({
      selected: state.selected,
      getOne: state.getOne,
    }),
    shallow
  )

  const surveyId = id ? parseInt(id, 10) : null
  const survey = selected?.survey ?? {}
  const isSurveyLoaded =
    surveyId != null && !Number.isNaN(surveyId) && survey?.id === surveyId

  useEffect(() => {
    if (surveyId == null || Number.isNaN(surveyId)) return
    if (survey?.id !== surveyId) {
      getOne(surveyId)
    }
  }, [getOne, survey?.id, surveyId])

  return {
    survey,
    selected,
    surveyId,
    isSurveyLoaded,
    getOne,
  }
}

export default useFetchSurveyDetail
